import { render } from "./PluginDialog.vue?vue&type=template&id=35d38170"
import script from "./PluginDialog.vue?vue&type=script&lang=js"
export * from "./PluginDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\topaz.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__